import React, { Component } from "react";
import styled from "styled-components";
import Modal from "react-modal";
import { Link, withRouter } from "react-router-dom";
import { graphql, QueryRenderer } from "react-relay";
import { Body } from "../Certificates";
import { FlexLeft, FlexEnd, ContainerWrapper, HrefCTA, ButtonCTA, FlexCenter, HelmetTitle } from "../../Components/Utils";
import Layout from "../../Components/Layout";
import environment from "../../Environment";
import Navigation from "../BannerItems/Components/Navigation";
import Banner from "../Certificates/Components/Banner";
import "./index.css";

import BannerBig from "../../Images/min-1600-hero.jpg";
import BannerSmall from "../../Images/max-600-hero.jpg"

const query = graphql`
  query Reviewers_Query {
    reviewers {
      id
      name
      title
      profile
      photo
      companyId
      company {
        name
        sector
        profile
        yearFounded
        logo
      }
    }
  }
`;

const Rflex = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 30px 0;
`;
const RflexItem = styled.div`
  background-color: rgb(247,249,248);
  border: 1px solid hsl(0,0%,95%);
  box-shadow: 4px 10px 20px 0 rgba(25,32,45,0.15);
  display: flex;
  flex-direction: column;
  word-wrap: break-word;
  overflow: hidden;
  min-height: 280px;
  text-align: center;
  border-radius: 0.25rem;
  min-width: 0;
  width: 240px;
  padding: 15px;
  margin: 10px;
  flex-wrap: wrap;
  cursor: pointer;
  &:hover {
    background-color: hsl(217,30%,75%);
  }
`;
const Rphoto = styled.div`
  height: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  img {
    border-radius: 5px;
    width: auto;
    height: 100px;
  }
`;
const RflexBody = styled.div`
  height: auto;
  max-height: 120px;
  
 > p {
    font-size: 95%;
    font-weight: 500;
    line-height: 1.5;
    margin-top: .5rem;
    margin-bottom: .5rem;
  }

`;
const RflexEnd = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  width: 100%;
  
  @media (min-width: 768px) {
    padding-right: 30px;
  }
  @media screen and (max-width: 600px) {
    align-items: center;
  }
`;
const RflexLeft = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;

  @media screen and (max-width: 600px) {
    align-items: center;
  }
`;
const ModalTop = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0;
  > div {
    flex-direction: column;
  }
  @media screen and (max-width: 600px) {
    flex-direction: column;	
  }
`;
const SpanClose = styled.span`
  position: absolute;
  top: 10px;
  right: 30px;
  font-size: 1.5rem;
  font-weight: 600;
  color: hsl(217,40%,40%);
  cursor: pointer;
`;
class Reviewers extends Component {
  constructor(props) {
    super(props);
    this.state = {
       showModal: false,
       person: undefined
    }
    this.handleItemClick = this.handleItemClick.bind(this);
    this.handleModalDisplay = this.handleModalDisplay.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  handleItemClick(rPerson) {
    this.setState({
      person: rPerson,
      showModal: true
    });
    
  }
  handleModalDisplay() {
   return  this.setState(prevState => ({showModal: !prevState.showModal}));
  }
  render() {
    const name = "Reviewers";
    return (
      <div className="App text">
      <HelmetTitle title="Reviewers" />
      <Layout
        head={
          <Navigation />
          }
        body={
          <React.Fragment>
            <Banner certName={name} imgPathMin={BannerBig} imgPathMax={BannerSmall} />
            <QueryRenderer 
              query={query}
              environment={environment}
              variables={{}}
              render={({error, props}) => {
                if (error || (props && !props.reviewers)) {
                  return <div>Error</div>;
                }
                if (!props) {
                  return <div>Loading...</div>;
                }
                let { reviewers } = props;
                
                console.log('reviewers..', reviewers);
                return (
                  <ContainerWrapper>
                  <Rflex>
                    {
                      reviewers && reviewers.map((person, index) => {
                        let { photo, name, title } = person;
                        let photoPath = require(`../../Images/Experience/Reviewers/${photo}`);
                        return (
                        <RflexItem onClick={() => this.handleItemClick(person)} key={index}>
                          <Rphoto>
                            <img src={photoPath} alt={name} title={name} />
                          </Rphoto>
                          <RflexBody>
                            <h4 style={{margin: ".5rem 0"}}>{name}</h4>
                            <p style={{margin: ".5rem 0"}}>{title}</p>
                          </RflexBody>
                        </RflexItem>
                        );
                    })
                    }
                  </Rflex>
                    <Rmodal showModal={this.state.showModal} handleModalDisplay={this.handleModalDisplay} person={this.state.person} />
                  </ContainerWrapper>
                )
              }}
            />
          </React.Fragment>
        }
      />
    </div>
    )
  }
}
const loadPhoto = (photo) => {
  if (photo) {
    return require(`../../Images/Experience/Reviewers/${photo}`);
  }
  else {
    return require(`../../Images/Experience/user.png`);
  }
}
const loadLogo = (logo) => {
  if (logo) {
    return require(`../../Images/Experience/Reviewers/${logo}`);
  }
 return "";
}
const Rmodal = (props) => {
  let {name, title, profile, photo, company} = props.person || "";
  
  return (
  <Modal
  isOpen={props.showModal}
  contentLabel="Reviewer"
  onRequestClose={props.handleModalDisplay}
  className="reviewer__modal"
>
<div>
{
  props.person &&
  <div>
  {company.map(c => {
    let k = 0;
    return (
    <div style={{padding: "10px"}} key={k++}>
    <SpanClose onClick={props.handleModalDisplay}>X</SpanClose>
      <ModalTop>
        <RflexLeft style={{flex: ".5"}}>
          <img src={photo && loadPhoto(photo)} alt={name && name} className="rModal__image" style={{borderRadius: "0.25rem"}} />
        </RflexLeft>
        <RflexLeft style={{flex: "2"}}>
          <h3 style={{margin: "0.5rem 0"}}>{name && name}</h3>
          <small>{title && title}</small>
        </RflexLeft>
        <RflexEnd style={{flex: "1"}}>
         <img src={c.logo && loadLogo(c.logo)} alt={c.name && c.name} className="rModal__image" />
        </RflexEnd>
      </ModalTop>
      <hr style={{borderColor: "rgba(0,0,0,.15)", borderBottom: "none"}} />
      <div style={{textAlign: "left"}}>
        <p>{profile && profile}</p>
      </div>
      <div style={{marginTop: "1.3rem", textAlign: "left"}}>
        <h4 style={{width: "100%", textAlign: "left"}}>
          {c.name && c.name} 
          <span style={{fontWeight: "400", fontSize: "90%", color: "hsl(217,30%,35%)", paddingLeft: "10px"}}>
            Founded {c.yearFounded && c.yearFounded} | {c.sector && c.sector}
          </span>
        </h4>
        <p>{c.profile && c.profile}</p>
      </div>
    </div>
    )})}
  </div>
}
   
</div>
 
</Modal>
  )
}

Modal.setAppElement('#root');

export default withRouter(Reviewers)



// WEBPACK FOOTER //
// ./src/Pages/Experiences/Reviewers.js